import { Box, Grid, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useMyMApi from '../../hooks/useMyMApi';
import useWebContext from '../../hooks/useWebContext';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { constants } from '../../constants';
import CustomTabs from '../../ui-parts/CustomTabs';
import CustomAccordion from '../../ui-parts/CustomAccordion';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import { MyMLink } from '../../ui-elements/MyMLink';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';

/**MyMine Version3.0 FAQ画面新規追加
 * FAQ Page Component
 */

const FAQ = () => {
  const screenId = 'MyM708';
  const apiRequest = useMyMApi(screenId);
  const { controlSettings } = useWebContext(screenId);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  const navigate = useNavigate();

  const onClickReferenceLink = (Link, ReferenceId, LinkType) => {
    switch (LinkType) {
      case constants.ReferenceLink.Url:
        apiRequest.requestJson('api/faq/faq_link?ReferenceId=' + ReferenceId, 'GET', null, null, null);
        window.open(Link, '_blank');
        break;
      case constants.ReferenceLink.Email:
        window.location.href = `mailto:${Link}`
        break;
      default:
        break;
    }
  }
  const [faqCategories, setFaqCategories] = useState([]);
  const isPc = useMediaQuery(mediaQuery.pc);


  useEffect(() => {
    const callbackSuccess = (result) => {

      if (result === null) {
        callbackFailed();
        return;
      }

      setFaqCategories(result.Categories);
      setIsLoading(false);
    }

    const callbackFailed = () => {
      setIsLoading(false);
      //エラーページ遷移
      navigate('/MyM999', { state: { message: constants.Message.InvalidRequest } });
    }
    apiRequest.requestJson('api/faq/faq-list', 'GET', callbackSuccess, callbackFailed);
    setIsLoading(true);
  }, []);

  if (faqCategories === [] || isLoading)
    return <MyMProgress />

  return (
    <Box className='py-1'>
      {isLoading && <MyMProgress />}
      <Box className='mb-2'>
        <MyMVariantLabel variant='h5' sx={{ fontSize: '28px' }}>{controlSettings.LabelList.lblFaqTitle}</MyMVariantLabel>
        <MyMLabel>{controlSettings.LabelList.lblFaqDescription}</MyMLabel>
      </Box>
      <Grid container alignItems="flex-start">
        <Grid item xs={12} sx={{ padding: isPc ? '30px 90px 0px 90px' : '30px 20px 0px 20px', }} >
          <CustomTabs
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={setSelectedTabIndex}
            tabCaptionList={faqCategories.map((category) => ({
              id: category.CategoryId,
              caption: category.CategoryName
            }))}
            tabContents={faqCategories.map((category, index) => (
              <Box key={category.CategoryId} sx={{ paddingTop: '0px' }}>
                {selectedTabIndex === index && (
                  category.questionHierarchyList.map((question, index) => (
                    <CustomAccordion
                      key={question.FaqId}
                      menuText={
                        <Grid container spacing={1} component="span">
                          <Grid item component="span">
                            <MyMLabel fontWeight="bold" whiteSpace="nowrap" component="span">
                              {controlSettings.LabelList.lblQuestion}
                            </MyMLabel>
                          </Grid>
                          <Grid item xs component="span">
                            <MyMLabel fontWeight="bold" component="span">
                              {question.FaqQuestionText}
                            </MyMLabel>
                          </Grid>
                        </Grid>
                      }
                      contents={
                        <Stack bgcolor='#fff'>
                          <Grid sx={{ height: '100%', padding: '10px' }}>
                            <Grid container spacing={1} sx={{ padding: '15px' }}>
                              <Grid item>
                                <MyMLabel fontWeight='bold'>{controlSettings.LabelList.lblAnswer}</MyMLabel>
                              </Grid>
                              <Grid item xs>
                                <Grid>
                                  <MyMLabel>{question.FaqAnswerText}</MyMLabel>
                                </Grid>
                                <Grid>
                                  {question.ReferenceLinks.map(({ ReferenceLink, ReferenceId, DisplayLink, LinkType }, index) => (
                                    <Grid container key={ReferenceLink + ReferenceId} sx={{ pt: index === 0 ? 2 : 0 }}>
                                      <Grid item className='d-flex align-items-start justify-content-start'>
                                        <MyMLabel>
                                          {
                                            LinkType === constants.ReferenceLink.Url &&
                                            controlSettings.LabelList[`lblReferenceUrl${index + 1}`]
                                          }
                                          {
                                            LinkType === constants.ReferenceLink.Email &&
                                            controlSettings.LabelList.lblReferenceEmail
                                          }
                                        </MyMLabel>
                                      </Grid>
                                      <Grid item xs={isPc ? 10 : 12} className='d-flex align-items-start justify-content-start'>
                                        <MyMLink
                                          href={ReferenceLink}
                                          underline="none"
                                          sx={{
                                            textAlign: 'left',
                                            '&:hover': {
                                              textDecoration: 'underline',
                                            }
                                          }}
                                          onClick={() => onClickReferenceLink(ReferenceLink, ReferenceId, LinkType)}
                                        >
                                          {DisplayLink ? DisplayLink : ReferenceLink}
                                        </MyMLink>
                                      </Grid>
                                    </Grid>
                                  ))}

                                </Grid>
                              </Grid>
                            </Grid>

                          </Grid>
                        </Stack>
                      }
                    />
                  ))
                )}
              </Box>
            ))}
          />
        </Grid>
        <Grid item xs={12} sx={{ padding: isPc ? '20px 100px 20px 100px' : '30px 20px 20px 20px', }}>
          <Box
            sx={{
              border: '2px solid #acacac',
              borderRadius: '5px',
              padding: '20px',
            }}
          >
            <Grid item className='d-flex align-items-center justify-content-center'>
              <MyMLabel fontSize='20px'>{controlSettings.LabelList.lblContentSupport}</MyMLabel>
            </Grid>
            <Grid item className='d-flex align-items-center justify-content-center' sx={{ padding: '10px 10px 0px 10px' }}>
              <NavigateLink to={'/MyM102/MyM701'} underline="none" >
                <Box sx={{
                  height: '50px',
                  width: '200px',
                  backgroundColor: '#7F7F7F',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '10px',
                }}>
                  <MyMLabel fontSize='1.3rem' sx={{ color: 'white' }}>{controlSettings.LabelList.btnContentSupport}</MyMLabel>
                </Box>
              </NavigateLink>
            </Grid>

          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FAQ;